module.exports = __webpack_public_path__ + "static/img/1692694710829.baef8270.jpg";